import {
  UserAssignedQualificationStatusType,
  UserQualificationResponse,
} from '@tabeeb/contracts/microservices/swagger-certificate-service'
import { Caption, Chip, Stack } from '@collaborate-health/uikit'
import React, { useMemo } from 'react'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

interface ContentUserQualificationChipProps {
  qualification: UserQualificationResponse
  variant?: 'chip' | 'text'
}

const ContentUserQualification: React.FC<ContentUserQualificationChipProps> = ({ qualification, variant = 'chip' }) => {
  const icon = useMemo(() => {
    const common = { sx: { verticalAlign: 'middle', fontSize: 'inherit' } }

    const hasActiveVersion = qualification.Versions?.some(
      (v) => v.Status === UserAssignedQualificationStatusType.Active
    )

    if (hasActiveVersion) {
      return <CheckCircleOutlineIcon color='success' {...common} />
    }
    return <ErrorOutlineIcon color='warning' {...common} />
  }, [qualification.Versions])

  if (variant === 'chip') {
    return <Chip label={qualification.QualificationName} size='small' variant='outlined' color='default' icon={icon} />
  }

  return (
    <Stack alignItems='center' gap={1} direction='row'>
      <Caption>{qualification.QualificationName}</Caption>
      {icon}
    </Stack>
  )
}

export default ContentUserQualification

